import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import Link from 'next/link'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useTranslation } from 'next-i18next'

const Faqs = () => {
  const { t } = useTranslation('partners-faqs')

  const FAQS = [
    {
      q: t('how_to_become.q'),
      a: t('how_to_become.a'),
    },
    {
      q: t('rates.q'),
      a: t('rates.a'),
    },
    {
      q: t('payment.q'),
      a: t('payment.a'),
    },
    {
      q: t('profile_name.q'),
      a: t('profile_name.a'),
    },
    {
      q: t('get_referrals.q'),
      a: t('get_referrals.a'),
    },
    {
      q: t('other_reasons.q'),
      a: t('other_reasons.a'),
    },
  ]

  return (
    <div className="mx-auto max-w-2xl">
      {FAQS.map((faq, i) => (
        <Disclosure key={i}>
          {({ open }) => (
            <div className="mb-2 last:mb-0">
              <DisclosureButton
                className={`w-full rounded-lg border border-th-bkg-3 p-4 text-left focus:outline-none md:hover:border-th-bkg-4 ${
                  open ? 'rounded-b-none border-b-0' : ''
                }`}
              >
                <div className="flex items-center justify-between">
                  <p className="text-base text-th-fgd-1">{faq.q}</p>
                  <ChevronDownIcon
                    className={`${
                      open ? 'rotate-180' : 'rotate-0'
                    } size-6 shrink-0 text-th-fgd-3`}
                  />
                </div>
              </DisclosureButton>
              <DisclosurePanel className="rounded-b-lg border border-t-0 border-th-bkg-3 p-4">
                <div className="prose prose-invert max-w-none">
                  <ReactMarkdown
                    components={{
                      h3: ({ children }) => (
                        <h3 className="mb-2 text-sm">{children}</h3>
                      ),
                      p: ({ children }) => (
                        <p className="mb-2 text-th-fgd-2">{children}</p>
                      ),
                      ul: ({ children }) => (
                        <ul className="mb-4 list-disc pl-6 text-th-fgd-2">
                          {children}
                        </ul>
                      ),
                      li: ({ children }) => (
                        <li className="mb-2 text-base text-th-fgd-2">
                          {children}
                        </li>
                      ),
                      a: ({ href, children }) => (
                        <Link
                          href={href || '#'}
                          className="text-th-active transition-colors hover:text-th-fgd-2"
                        >
                          {children}
                        </Link>
                      ),
                    }}
                    remarkPlugins={[remarkGfm]}
                  >
                    {faq.a}
                  </ReactMarkdown>
                </div>
              </DisclosurePanel>
            </div>
          )}
        </Disclosure>
      ))}
    </div>
  )
}

export default Faqs
